import { render } from "./DataSider.vue?vue&type=template&id=d1bb7ab0&scoped=true"
import script from "./DataSider.vue?vue&type=script&lang=js"
export * from "./DataSider.vue?vue&type=script&lang=js"

import "./DataSider.vue?vue&type=style&index=0&id=d1bb7ab0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d1bb7ab0"

export default script